// Some AI-generated narrative fields (e.g. Beneficial Ownership's
// general_description/sanctions_summary) come back as one continuous wall of
// text with no embedded line breaks at all. This reflows that text into
// paragraph-sized chunks for readability -- shared by the PDF report
// (EntityTicketPdf.ts) and the ticket results page so both present the same
// summary the same way.

// Strips non-printable control-character code points (built from numeric
// escapes, not raw bytes, so nothing invisible ends up in this source file).
const CONTROL_CHARS_RE = new RegExp(
  '[\\u0000-\\u0008\\u000B\\u000C\\u000E-\\u001F\\u007F]',
  'g',
);

const cleanText = (input: any): string =>
  String(input === null || input === undefined ? '' : input)
    .replace(CONTROL_CHARS_RE, '')
    .replace(/[\t\n\r]+/g, ' ')
    .trim();

// Naive regex sentence splitting (no NLP) -- the negative lookbehind guards
// the common "U.S./U.K./E.U." two-letter-abbreviation case, but a word
// abbreviation like "Corp." or "Inc." followed by a capitalized word can
// still over-split. Acceptable for a readability heuristic, not exact prose
// parsing.
const SENTENCE_BOUNDARY_RE = /(?<![A-Z]\.[A-Z]\.)(?<=[.!?])\s+(?=[A-Z"'(])/g;

export const reflowIntoParagraphs = (
  input: any,
  sentencesPerParagraph = 3,
): string[] => {
  const text = cleanText(input);
  if (!text) {
    return [];
  }

  const sentences = text.split(SENTENCE_BOUNDARY_RE).filter(Boolean);
  if (sentences.length <= sentencesPerParagraph) {
    return [text];
  }

  const paragraphs: string[] = [];
  for (let i = 0; i < sentences.length; i += sentencesPerParagraph) {
    paragraphs.push(
      sentences
        .slice(i, i + sentencesPerParagraph)
        .join(' ')
        .trim(),
    );
  }
  return paragraphs;
};
